import { IModel } from '@alberta/konexi-shared';
import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

import { AccountService } from '../services/account.service';
import { BaseAuthorizationDirective } from './base-authorization.directive';

@Directive({
  selector: '[itl-authorizeWithSelection]',
  standalone: false,
})
export class AuthorizationWithSelectionDirective extends BaseAuthorizationDirective implements OnChanges {
  @Input('itl-authorizeWithSelection') selectedItem: IModel;

  constructor(elementRef: ElementRef, renderer: Renderer2, accountService: AccountService) {
    super(accountService, elementRef, renderer);
  }

  async ngOnChanges() {
    if (this.selectedItem == null) {
      return;
    }

    await super.setVisibility();
  }
}
